import PenaltyManagementRepositoryImpl from './impl/PenaltyManagementRepositoryImpl'

export default {
  getInstance () {
    return new PenaltyManagementRepositoryImpl()
  }
}
